
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M2.642 9.18c.47 0 .913-.183 1.246-.516l1.8-1.8a.342.342 0 01.473 0L7.968 8.67c.332.333.775.516 1.246.516h.355l-2.28 2.28a1.823 1.823 0 01-2.578 0L2.425 9.18h.217zM9.214 2.813c-.47 0-.914.184-1.247.517L6.161 5.136a.335.335 0 01-.473 0l-1.8-1.8a1.752 1.752 0 00-1.246-.516h-.217L4.71.534a1.823 1.823 0 012.578 0l2.28 2.28h-.355z"}}),_c('path',{attrs:{"d":"M.534 4.71l1.381-1.38c.03.012.064.02.099.02h.628c.324 0 .642.13.872.36l1.8 1.8a.861.861 0 001.221 0l1.807-1.806c.23-.23.547-.361.872-.361h.772a.262.262 0 00.093-.02l1.387 1.388a1.823 1.823 0 010 2.578l-1.387 1.387a.262.262 0 00-.093-.019h-.772c-.325 0-.643-.131-.872-.361L6.535 6.49a.885.885 0 00-1.221 0l-1.8 1.8c-.23.23-.548.36-.872.36h-.628a.263.263 0 00-.099.02L.534 7.29a1.823 1.823 0 010-2.58z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    